<dx-popup
  [visible]="displayDialog"
  [height]="500"
  [width]="600"
  (onHiding)="closeDialog()"
  title="Exporter les données d'analyse financière"
>
  <dx-tab-panel (onTitleClick)="tabChange($event)">
    <dxi-item title="Facturation par prestation">
      <div class="export-settings">
        <yo-tagbox
          [data]="pointFacturationList"
          [selectedItems]="selectedPointFacturationList"
          (onValueChange)="updateValuePrestation($event, cellTypes.POINT_FACTURATION)"
          placeholder="Point de facturation">
        </yo-tagbox>
        <yo-tagbox
          [data]="pointLivraisonList"
          [selectedItems]="selectedPointLivraisonList"
          (onValueChange)="updateValuePrestation($event, cellTypes.POINT_LIVRAISON)"
          [disabled]="!isParentSelected(selectedPointFacturationList)"
          placeholder="Point de livraison">
        </yo-tagbox>
        <yo-tagbox
          [data]="offreAlimentaireList"
          [selectedItems]="selectedOffreAlimentaireList"
          (onValueChange)="updateValuePrestation($event, cellTypes.OFFRE_ALIMENTAIRE)"
          [disabled]="!isParentSelected(selectedPointLivraisonList)"
          placeholder="Offre alimentaire">
        </yo-tagbox>
        <yo-tagbox
          [data]="prestationList"
          [selectedItems]="selectedPrestationList"
          (onValueChange)="updateValuePrestation($event, cellTypes.PRESTATION)"
          [disabled]="!isParentSelected(selectedOffreAlimentaireList)"
          placeholder="Prestation">
        </yo-tagbox>
        <yo-tagbox
          [data]="repasList"
          [selectedItems]="selectedRepasList"
          (onValueChange)="updateValuePrestation($event, cellTypes.REPAS)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Repas">
        </yo-tagbox>
        <yo-tagbox
          [data]="regimeList"
          [selectedItems]="selectedRegimeList"
          (onValueChange)="updateValuePrestation($event, cellTypes.REGIME)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Régime">
        </yo-tagbox>
        <div class="d-flex flex-row align-items-center">
        <yo-date-range-box
          (onValueChange)="onDateFilterValueChange($event)"
          height="45px"
          [selectedDates]="selectedPeriode"
        >
        </yo-date-range-box>
          <yo-button
            class="ml-2"
            iconClass="fa fa-check"
            buttonClass="cta-success"
            (onClick)="export(typeExport.PRESTATION)">
          </yo-button>
        </div>
      </div>
    </dxi-item>

    <dxi-item title="Facturation par plat">
      <div class="export-settings">
        <yo-tagbox
          [data]="pointLivraisonList"
          [selectedItems]="selectedPointLivraisonList"
          (onValueChange)="updateValuePlat($event, cellTypes.POINT_LIVRAISON)"
          placeholder="Point de livraison">
        </yo-tagbox>
        <yo-tagbox
          [data]="offreAlimentaireList"
          [selectedItems]="selectedOffreAlimentaireList"
          (onValueChange)="updateValuePlat($event, cellTypes.OFFRE_ALIMENTAIRE)"
          [disabled]="!isParentSelected(selectedPointLivraisonList)"
          placeholder="Offre alimentaire">
        </yo-tagbox>
        <yo-tagbox
          [data]="prestationList"
          [selectedItems]="selectedPrestationList"
          (onValueChange)="updateValuePlat($event, cellTypes.PRESTATION)"
          [disabled]="!isParentSelected(selectedOffreAlimentaireList)"
          placeholder="Prestation">
        </yo-tagbox>
        <yo-tagbox
          [data]="repasList"
          [selectedItems]="selectedRepasList"
          (onValueChange)="updateValuePlat($event, cellTypes.REPAS)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Repas">
        </yo-tagbox>
        <yo-tagbox
          [data]="regimeList"
          [selectedItems]="selectedRegimeList"
          (onValueChange)="updateValuePlat($event, cellTypes.REGIME)"
          [disabled]="!isParentSelected(selectedPrestationList)"
          placeholder="Régime">
        </yo-tagbox>
        <div class="d-flex flex-row align-items-center">
          <yo-date-range-box
            (onValueChange)="onDateFilterValueChange($event)"
            height="45px"
            [selectedDates]="selectedPeriode"
          >

          </yo-date-range-box>
          <yo-button
            class="ml-2"
            iconClass="fa fa-check"
            buttonClass="cta-success"
            (onClick)="export(typeExport.PLAT)">
          </yo-button>
        </div>
      </div>
    </dxi-item>
  </dx-tab-panel>
</dx-popup>
